<template>
  <v-row no-gutters class="filial-metrics indicators-row">
    <v-col>
      <reviews-rating-metric />
    </v-col>
    <v-col v-for="metric in filialMetrics" :key="metric.key">
      <filial-metric :metric="metric" />
    </v-col>
  </v-row>
</template>

<script>
  import { mapGetters } from 'vuex'
  import FilialMetric from './FilialMetric.vue'
  import ReviewsRatingMetric from './filial-metrics/ReviewsRatingMetric.vue'

  export default {
    name: 'FilialMetrics',
    components: { FilialMetric, ReviewsRatingMetric },
    computed: {
      ...mapGetters({
        filialMetrics: 'indicators/getFilialMetrics',
        thresholdColors: 'indicators/getThresholdColors',
      }),
    },
  }
</script>

<style lang="less" scoped>
.filial-metrics {
  flex-grow: 0;
  flex-wrap: nowrap;

  .media-sm({
      margin-bottom: 10px;
      margin-right: 5px;
      flex-wrap: wrap !important;

      .col {
        padding: 5px;
        flex: 0 0 33.3333333333%;
        max-width: 33.3333333333%;

        &:last-child {
          flex: 0 0 100%;
          max-width: 100%;
        }
      }
    });

  .sheet-orders-count {
    margin-right: 5px;
  }
  .sheet-total {
    margin-right: 5px;
  }
}
</style>
